import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Modal = ({ children, ...props }) => {
    const { title, desc, isModalOpen, setIsModalOpen, style } = props;

    const modalClose = () => {
        setIsModalOpen(false);
    };

    // 모달 바깥 영역 클릭시 닫힘
    const handleBgClick = e => {
		if (e.target === e.currentTarget) {
			modalClose()
		}
	}

    // ESC 키 누르면 닫힘
    useEffect(() => {
		const onKeyDown = e => {
			if (e.key === "Escape") {
				modalClose()
			}
		}
		if (isModalOpen) {
			document.addEventListener("keydown", onKeyDown)
		}
		return () => {
			document.removeEventListener("keydown", onKeyDown)
		}
	}, [isModalOpen])

    return (
        <>
            {isModalOpen ? (
                <CustomModalBg onClick={handleBgClick}>
                    <CustomModalInner style={style}>
                        <Title>
                            <h4>{title}</h4>
                            <CustomCloseBtn onClick={modalClose}>X</CustomCloseBtn>
                        </Title>
                        <div className="title-desc" style={{margin: "5px 0 20px 0"}}>{desc}</div>    
                        {children}
                    </CustomModalInner>
                </CustomModalBg>
            ) : null}
        </>
    );
};

const Wrap = styled.div`
    display: flex;

    ${(props) => props.col && `flex-direction: column;`}
    ${(props) => props.row && `flex-direction: row;`}
    ${(props) => props.gap && `gap: ${props.gap}`}
`;

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const CustomCloseBtn = styled.button`
    align-self: flex-end;
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
    background-color: transparent;
    border-color: transparent;

    &:hover {
        background-color: var(--light-color);
    }
`;

const CustomModalBg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    gap: 5px;
`;

const CustomModalInner = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px;
    min-width: 700px;
    max-width: 80vw;
    max-height: 80vh;
    overflow-y: auto;
    background-color: #fff;
`;

export default Modal;